import React from 'react';
import './StatusOverview.css'
import {IconFilePDF} from "./Icons";
import {PublicApiConsignmentResponse} from "../Representation";


interface StatusOverviewProps {
    apiOrigin: string
    trackingToken: string
    consignment: PublicApiConsignmentResponse
}

const StatusOverview = (
    props: StatusOverviewProps
) => {

    const { consignment } = props;

    return (
        <div className="status-overview">
            {'CANCELLED' !== consignment.status &&
                <p>Delivery window {consignment.formattedDeliveryFromTo}</p>
            }

            {'ASSIGNED' === consignment.status && consignment.eta &&
                <div>
                    <h2>Scheduled Time of Arrival <span className="primary-color">{consignment.formattedETA}</span></h2>
                    <p className="eta-disclaimer">
                        This is an approximate time and may be subject to change.<br />
                        You will receive a notification when the delivery has started.
                    </p>
                </div>
            }

            {'STARTED' === consignment.status && consignment.eta &&
                <div>
                    <h2>Estimated Time of Arrival <span className="primary-color">{consignment.formattedETA}</span></h2>
                    <p className="eta-disclaimer">
                        This is an an approximate time and may be subject to change.
                    </p>
                </div>
            }

            {'COMPLETED' === consignment.status &&
                <div>
                    <h2>Delivery completed <span className="primary-color">{consignment.formattedCompletedAt}</span></h2>
                    {consignment.podAvailable &&
                        <p className="primary-colour">
                            <IconFilePDF />
                            <a className="btn btn-download"
                               target="_subtrux_proof_of_delivery"
                               href={`${props.apiOrigin}/tracking/${props.trackingToken}/proof-of-delivery`}
                            >Download Proof of Delivery</a>
                        </p>}
                </div>
            }

            {'CANCELLED' === consignment.status &&
                <div>
                    <h2>Delivery cancelled <span className="primary-color">{consignment.formattedCancelledAt}</span></h2>
                </div>
            }
        </div>
    )

}

export default StatusOverview;
